module.exports = __webpack_public_path__ + "static/a-xx-222-art-4a523aa83ab73d2d4d75ad18477c619a.jpg";